import { useProfile } from "@/context/useProfileProps";
import { Button, LeftArrow, Modal } from "@monsterindia/global-ui-components";
import React from "react";

import { FooterDataProps } from "@/components/common/profileModal/types";

const ProfileModal = ({
  children,
  screenAlignment,
  customClass,
  ...props
}: any) => {
  const isMobile = props.isMobile ?? useProfile();
  const search = window.location.search;
  let urlParams = new URLSearchParams(search);
  const isApp = urlParams.get("app");
  const renderHeader = (
    <div className="flex items-center justify-between gap-2">
      <div className="flex w-full items-center gap-1">
        {props.backBtnhandler ? (
          <Button
            className="!p-0"
            leftIcon={
              <LeftArrow className={"text-black"} width={18} height={18} />
            }
            aria-labelledby="Back"
            aria-label="Back"
            title="Back"
            onClick={props.backBtnhandler}
          />
        ) : null}
        <h4 className="text-base font-bold text-black">{props.heading}</h4>
      </div>
      {props.rightBtn ? props.rightBtn : null}
    </div>
  );

  let footerData: FooterDataProps[] = [];

  if (props.footerPrimaryBtnLabel) {
    footerData.unshift({
      type: "primary",
      label: props.footerPrimaryBtnLabel,
      onClick: props.footerPrimaryBtnHandler ?? (() => {}),
      className: `${isMobile ? "w-full" : "ml-auto max-w-[152px]"}`,
      isLoading: !!props.footerPrimaryBtnIsLoading,
      disabled: !!props.footerSecondaryBtnIsLoading,
    });
  }

  if (!isMobile && props.footerSecondaryBtnLabel) {
    footerData.unshift({
      type: "tertiary",
      label: props.footerSecondaryBtnLabel,
      onClick: props.footerSecondaryBtnHandler ?? (() => {}),
      className: "w-max text-darkKnight-500",
      isLoading:
        !!props.footerSecondaryBtnIsLoading ||
        !!props.footerPrimaryBtnIsLoading,
    });
  }

  return (
    <Modal
      {...props}
      header={renderHeader}
      screenAlignment={screenAlignment}
      showHandleBar={screenAlignment === "bottom-sheet"}
      footer={footerData && footerData.length > 0 ? footerData : undefined}
      footerContainerClass={isMobile ? "" : "rounded-b-2xl"}
      customClass={` ${isMobile ? "flex flex-col justify-between" : "w-[45vw] max-h-[60vh] h-auto"} ${isMobile && isApp ? "h-[70vh]" : ""}  ${customClass ?? ""}`}
      customContentContainerClass="flex flex-col"
      closeOnOutsideClick={!isApp}
    >
      {children}
      {isMobile && props.footerSecondaryBtnLabel && (
        <Button
          key="tertiary-btn"
          modifier="tertiary"
          onClick={props.footerSecondaryBtnHandler}
          label={props.footerSecondaryBtnLabel}
          className="text-darkKnight-500 mt-5 w-full"
        />
      )}
    </Modal>
  );
};

export default ProfileModal;
